
import { MutationTree } from 'vuex';
import { AuthInterface } from './state';


const mutation: MutationTree<AuthInterface> = {
    setUserSession( state: AuthInterface, payload: any ) {
        state.nombre = payload.nombre;
        state.tipo = payload.tipo;
        state.id_usuario = payload.id_usuario;
    },
    setKeepaliveInterval (state, payload){
        state.keepaliveInterval = payload;
    }
}


export default mutation;